import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-marquee-shopzovya';
const html = `
<div class="wrap-marquees">
  <div data-attribute="row-marquee" data-bg-badge="#f7c4ce" data-bg-item="#ffffff" data-color-badge="#ffffff"
    data-gap-item="28" data-speed-animation="40" class="row-marquee"
    style="--speed-animation:40s; --gap-item:28px; --bg-badge:#f7c4ce; --color-badge:#ffffff; --bg-item:#ffffff;">
    <div class="list-item">
      <div data-attribute="marquee-item" class="marquee-item">
        <div class="wrap-avatar">
          <div class="avatar">
            <img data-attribute="avatar"
              src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e250154ded48c0465f314.jpg"
              alt="">
          </div>
          <div class="rating">
            <span data-attribute="rating-point" data-value="5">5</span>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="currentColor"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
        </div>
        <p data-attribute="text-rating" class="text-rating">
          Honestly wish I bought these sooner
        </p>
      </div>
      <div data-attribute="marquee-item" class="marquee-item">
        <div class="wrap-avatar">
          <div class="avatar">
            <img data-attribute="avatar"
              src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e250154ded48c0465f314.jpg"
              alt="">
          </div>
          <div class="rating">
            <span data-attribute="rating-point" data-value="5">5</span>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="currentColor"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
        </div>
        <p data-attribute="text-rating" class="text-rating">
          Honestly wish I bought these sooner
        </p>
      </div>
      <div data-attribute="marquee-item" class="marquee-item">
        <div class="wrap-avatar">
          <div class="avatar">
            <img data-attribute="avatar"
              src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e250154ded48c0465f314.jpg"
              alt="">
          </div>
          <div class="rating">
            <span data-attribute="rating-point" data-value="5">5</span>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="currentColor"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
        </div>
        <p data-attribute="text-rating" class="text-rating">
          Honestly wish I bought these sooner
        </p>
      </div>

    </div>
  </div>
  <div data-attribute="row-marquee" data-bg-badge="#f7c4ce" data-bg-item="#ffffff" data-color-badge="#ffffff"
    data-gap-item="28" data-speed-animation="40" class="row-marquee"
    style="--speed-animation:40s; --gap-item:28px; --bg-badge:#f7c4ce; --color-badge:#ffffff; --bg-item:#ffffff;">
    <div class="list-item">
      <div data-attribute="marquee-item" class="marquee-item">
        <div class="wrap-avatar">
          <div class="avatar">
            <img data-attribute="avatar"
              src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e250154ded48c0465f314.jpg"
              alt="">
          </div>
          <div class="rating">
            <span data-attribute="rating-point" data-value="5">5</span>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="currentColor"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
        </div>
        <p data-attribute="text-rating" class="text-rating">
          Honestly wish I bought these sooner
        </p>
      </div>
      <div data-attribute="marquee-item" class="marquee-item">
        <div class="wrap-avatar">
          <div class="avatar">
            <img data-attribute="avatar"
              src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e250154ded48c0465f314.jpg"
              alt="">
          </div>
          <div class="rating">
            <span data-attribute="rating-point" data-value="5">5</span>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="currentColor"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
        </div>
        <p data-attribute="text-rating" class="text-rating">
          Honestly wish I bought these sooner
        </p>
      </div>
      <div data-attribute="marquee-item" class="marquee-item">
        <div class="wrap-avatar">
          <div class="avatar">
            <img data-attribute="avatar"
              src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e250154ded48c0465f314.jpg"
              alt="">
          </div>
          <div class="rating">
            <span data-attribute="rating-point" data-value="5">5</span>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="currentColor"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
        </div>
        <p data-attribute="text-rating" class="text-rating">
          Honestly wish I bought these sooner
        </p>
      </div>

    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
